<template>
  <div id="tab-license-add-boat">
    <form>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full license-col-min-width">
          <label class="vs-input--label">小型船舶種別</label>
          <v-select
            placeholder="免許種別を選択してください"
            class="w-full v-select-license-add"
            label="label"
            name="selectLicense"
            :options="boatOperatorLicenseOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="inputForm.licenseTypeId"
            v-validate="'required'"
            data-vv-as="免許種別"
          >
            <template v-slot:no-options>免許種別が見つかりません</template>
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectLicense')"
            >{{ errors.first("selectLicense") }}</span
          >
        </div>
        <div class="vx-col md:w-1/4 w-full license-col-min-width">
          <label class="vs-input--label">有効期限</label>
          <datepicker
            name="selectExpirationDate"
            :language="ja"
            :format="formatter"
            :typeable="true"
            placeholder="日付を選択してください"
            v-model="inputForm.expirationDate"
            v-validate="'required'"
            data-vv-as="有効期限"
            :disabled-dates="disabledDates"
            ref="datePickerExpirationDate"
          ></datepicker>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectExpirationDate')"
            >{{ errors.first("selectExpirationDate") }}</span
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 mt-8 mb-8 w-full license-col-min-width">
          <input-image
            :label="'免許証の画像'"
            ref="inputImage"
            @onSetImage="onSetImage"
            @onClearImage="onClearImage"
          ></input-image>
        </div>
        <div class="vx-col md:w-1/4 w-full input-form-memo license-col-min-width">
          <label class="vs-input--label">メモ</label>
          <vs-textarea v-model="inputForm.memo" width="100%" height="200px"/>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import LicenseMixin from "@/mixins/LicenseMixin";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import InputImage from "@/components/formElemens/input/InputImage";
import { FileUtil } from "@/utils";

const { mapActions } = createNamespacedHelpers("enterpriseLicenseAdd");

export default {
  data() {
    return {
      inputForm: {
        licenseTypeId: null,
        expirationDate: null,
        memo: null,
      },
      disabledDates: {
        to: new Date(),
      },
    };
  },
  components: {
    vSelect,
    Datepicker,
    InputImage
  },
  mixins: [LicenseMixin, DatepickerMixin],
  methods: {
    ...mapActions(["setInputForm", "setPictureSrc", "clearPictureSrc"]),

    onSetImage(evt) {
      let blob = FileUtil.toBlob(evt.src, evt.type);
      this.setPictureSrc(blob);
    },

    onClearImage() {
      this.clearPictureSrc();
    },

    async validate() {
      let result = await this.$validator.validateAll();
      if (result) {
        let payload = {
          name: "小型船舶免許" ,
          license_type_id: this.inputForm.licenseTypeId.value,
          expiration_date: this.inputForm.expirationDate,
          memo: this.inputForm.memo,
        };
        await this.setInputForm(payload);
      }
      return result;
    }
  },
  mounted() {
    this.customizeExpirationDateElement(this.$refs.datePickerExpirationDate.$el);
  },
};
</script>

<style lang="scss">
.vs-button {
  .text-small {
    font-size: small;
  }
}

.text-font-bolder {
  font-weight: bolder;
}

.v-select-license-add {
  .vs__selected {
    padding: 0.24rem 0.24rem 0.24rem 0.62rem !important;
  }
  .vs__search {
    padding: 0.24rem 0.24rem 0.24rem 0.62rem !important;
  }
}

.vs__dropdown-toggle {
  border-radius: 5px;
}

#tab-license-add-boat {
  .license-col-min-width {
    min-width: 220px;
  }
  .input-form-memo {
    padding-top: 2rem;
    .vs-con-textarea {
      margin-top: 0.6rem;
    }
    .vs-textarea {
      height: 200px;
    }
  }
}

</style>
